
import { InputHelperText, InputProps, useInput } from "react-admin";
import { TextField,  Stack } from "@mui/material";
import { ChangeEvent } from "react";

interface Location {
    coordinates: [number | null, number | null] | null;
}

interface LocationInputProps extends InputProps {
    source: string;
}

const validateCoordinates = (value: Location) => {
    console.log("validate", value)
    if (value?.coordinates == null) return undefined;

    if (!Array.isArray(value.coordinates) || value.coordinates.length !== 2) {
        return "Invalid location format.";
    }
    const [longitude, latitude] = value.coordinates;
    if (longitude == null && latitude == null) {
        return undefined; // Allow null when both are empty
    }
    if (longitude == null || latitude == null) {
        return "Both longitude and latitude are required.";
    }

    if (Number.isNaN(longitude) || Number.isNaN(latitude)) {
        return "Coordinates must be valid numbers.";
    }

    if (longitude < -180 || longitude > 180) {
        return "Longitude must be between -180 and 180.";
    }

    if (latitude < -90 || latitude > 90) {
        return "Latitude must be between -90 and 90.";
    }
    return undefined;
};

export const LocationInput = ({ source, label }: LocationInputProps) => {
    const {
        field,
        fieldState: { invalid, error },
        isRequired,
    } = useInput<Location>({ source, validate: validateCoordinates });

    const value: Location = field.value ?? null;

    const handleChange = (index: number, event: ChangeEvent<HTMLInputElement>) => {
        const coordinates: [number | null, number | null] = [...(value?.coordinates ?? [null, null])];
        const parsedValue = event.target.value.trim() === "" ? null : parseFloat(event.target.value);
        coordinates[index] = Number.isNaN(parsedValue) ? null : parsedValue;
        field.onChange(coordinates[0] == null && coordinates[1] == null ? null : { coordinates, type: "Point" });
    };

    return (
        <Stack direction={"row"} gap={1} alignItems="center">
            <TextField
                label="Longitude"
                variant="outlined"
                type="number"
                value={value.coordinates?.[0] ?? ""}
                onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(0, e)}
                error={invalid}
                helperText={
                    <InputHelperText
                        error={error?.message}
                        helperText={false}
                    />
                }
            />
            <TextField
                label="Latitude"
                variant="outlined"
                type="number"
                value={value.coordinates?.[1] ?? ""}
                onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(1, e)}
                error={invalid}
                helperText={
                    <InputHelperText
                        error={error?.message}
                        helperText={false}
                    />
                }
            />

        </Stack>
    );
};


